import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const TripTypeSelector = ({ selectedType, onTypeSelect, error }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const tripTypes = [
    { id: 'beach', name: 'Beach', icon: 'Waves', description: 'Relax on pristine beaches' },
    { id: 'city-break', name: 'City Break', icon: 'Building2', description: 'Explore vibrant cities' },
    { id: 'family', name: 'Family', icon: 'Users', description: 'Fun for all ages' },
    { id: 'couples-romantic', name: 'Couples / Romantic Getaway', icon: 'Heart', description: 'Romantic experiences' },
    { id: 'honeymoon', name: 'Honeymoon', icon: 'Heart', description: 'Special romantic getaways' },
    { id: 'short-break', name: 'Short Break / Weekend Away', icon: 'Calendar', description: 'Quick escapes' },
    { id: 'all-inclusive', name: 'All-Inclusive Resort', icon: 'Building', description: 'Everything included' },
    { id: 'luxury', name: 'Luxury', icon: 'Crown', description: 'Premium experiences' },
    { id: 'golf', name: 'Golf', icon: 'Target', description: 'Championship courses' },
    { id: 'ski', name: 'Ski / Snow', icon: 'Snowflake', description: 'Winter sports adventures' },
    { id: 'cruise', name: 'Cruise', icon: 'Ship', description: 'Luxury ocean voyages' },
    { id: 'adventure', name: 'Adventure', icon: 'Mountain', description: 'Thrilling outdoor experiences' },
    { id: 'wellness-spa', name: 'Wellness & Spa Retreat', icon: 'Flower', description: 'Health and relaxation' },
    { id: 'safari-wildlife', name: 'Safari / Wildlife', icon: 'Binoculars', description: 'Amazing animal encounters' },
    { id: 'food-wine', name: 'Food & Wine', icon: 'Wine', description: 'Culinary experiences' },
    { id: 'multi-centre', name: 'Multi-Centre', icon: 'MapPin', description: 'Multiple destinations' },
    { id: 'cultural-heritage', name: 'Cultural & Heritage', icon: 'Landmark', description: 'Discover history and heritage' },
    { id: 'group', name: 'Group', icon: 'Users', description: 'Friends and colleagues' }
  ];

  const filteredTypes = tripTypes?.filter(type =>
    type?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
    type?.description?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  );

  return (
    <div className="space-y-4">
      <div className="relative">
        <Icon name="Search" size={20} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" />
        <input
          type="text"
          placeholder="Search trip types..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e?.target?.value)}
          className="w-full pl-10 pr-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
        />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {filteredTypes?.map((type) => (
          <button
            key={type?.id}
            onClick={() => onTypeSelect(type?.id)}
            className={`p-4 rounded-lg border-2 text-left transition-all hover:scale-105 ${
              selectedType === type?.id
                ? 'border-primary bg-primary/5 shadow-md'
                : 'border-border hover:border-primary/50 hover:bg-muted/50'
            }`}
          >
            <div className="flex items-start space-x-3">
              <div className={`p-2 rounded-lg ${
                selectedType === type?.id ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'
              }`}>
                <Icon name={type?.icon} size={20} />
              </div>
              <div className="flex-1">
                <h3 className={`font-medium ${
                  selectedType === type?.id ? 'text-primary' : 'text-foreground'
                }`}>
                  {type?.name}
                </h3>
                <p className="text-sm text-muted-foreground mt-1">
                  {type?.description}
                </p>
              </div>
            </div>
          </button>
        ))}
      </div>
      {filteredTypes?.length === 0 && (
        <div className="text-center py-8">
          <Icon name="Search" size={32} className="mx-auto mb-3 text-muted-foreground opacity-50" />
          <p className="text-muted-foreground">No trip types found matching "{searchTerm}"</p>
        </div>
      )}
      {error && (
        <p className="text-error text-sm mt-2">{error}</p>
      )}
    </div>
  );
};

export default TripTypeSelector;